module.exports = __webpack_public_path__ + "static/media/phone_6.d14f70ec.png";